import axios from 'axios'

import type { Manual } from '../types/release.type'

export interface ISearchDocs {
  query: string
}

export type FetchReleaseResponse = {
  docs: Manual[]
}

export const searchDocsService = async ({
  query,
}: ISearchDocs): Promise<FetchReleaseResponse> => {
  const response = await axios.get(
    `https://api-plataforma.cnesistemas.com.br/api/manuals?query=${query}&projectId=89ABE984-D90D-4308-8DE6-402C4F72638A&page=1&limit=1000`,
  )

  return {
    docs: response.data,
  }
}
